import React from 'react';
import { Box, Flex, SpacingStack, TextV2 } from '@withjoy/joykit';

import { format } from 'date-fns';
import { CustomerProductReviewFragment } from '@graphql/generated';
import { SkeletonText } from '@shared/components/Skeleton';
import { useTranslation } from '@shared/core';
import { StarRating } from '../../../ProductRating';

export const ReviewListItem = ({ review }: { review: CustomerProductReviewFragment }) => {
  const { t } = useTranslation('catalogRegistry');
  return (
    <Flex flexDirection={'column'}>
      <SpacingStack spacing={5}>
        <StarRating
          id={review.id}
          rating={review.ratingBucket}
          iconSize={'sm'}
        />
        <TextV2 typographyVariant="body1">{review.description}</TextV2>
        {!!review.mediaAssets.length && (
          <Flex __css={{ columnGap: 5 }}>
            {review.mediaAssets.map((asset, idx) => {
              if (asset.__typename !== 'RatingReviewPhotoAsset') {
                return null;
              }
              return (
                <Box
                  key={`${asset.__typename}${idx}`}
                  __css={{
                    backgroundImage: `url('${asset.photo.normal.url}')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    size: 120,
                  }}
                />
              );
            })}
          </Flex>
        )}
      </SpacingStack>
      <Flex __css={{ flexDirection: 'column', marginTop: 6 }}>
        <TextV2 typographyVariant="hed1">{review.authorName || t('catalogItemCustomerReviewsSection', 'reviewList', 'unknownReviewAuthor')()}</TextV2>
        <TextV2
          marginTop={1}
          typographyVariant="label1"
        >
          {format(review.submittedAt.milliseconds, 'MMMM yyyy')}
        </TextV2>
        {review.syndicationSource && (
          <SpacingStack
            marginTop={5}
            alignItems="center"
            stack="horizontal"
            spacing={3}
          >
            {review.syndicationSource.logoImage && (
              <Box
                as="img"
                __css={{ width: ['50px'] }}
                src={review.syndicationSource.logoImage.url}
              />
            )}
            <TextV2
              typographyVariant="label1"
              color="mono10"
            >
              {t('catalogItemCustomerReviewsSection', 'reviewList', 'syndicationSourceNotice')({ source: review.syndicationSource.name })}
            </TextV2>
          </SpacingStack>
        )}
      </Flex>
    </Flex>
  );
};

ReviewListItem.Skeleton = () => {
  return (
    <Flex flexDirection={'column'}>
      <SpacingStack spacing={5}>
        <SkeletonText
          rows={1}
          width={136}
          skeletonHeight={24}
        />
        <SkeletonText skeletonHeight={22.5} />
      </SpacingStack>
      <Flex __css={{ flexDirection: 'column', marginTop: 6 }}>
        <SkeletonText
          rows={1}
          skeletonHeight={21}
          width={100}
        />
        <SkeletonText
          marginTop={1}
          rows={1}
          width={75}
          skeletonHeight={14}
        />
      </Flex>
    </Flex>
  );
};
